import React from "react";

export default function StatTile({ label, value, accent, sub, testId }) {
  return (
    <div
      className="border border-neutral-900 bg-neutral-950 p-6 hover:bg-neutral-900/40 transition-colors"
      data-testid={testId}
    >
      <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
        {label}
      </div>
      <div
        className="font-heading text-3xl md:text-4xl font-semibold tracking-tight"
        style={accent ? { color: accent } : {}}
      >
        {value}
      </div>
      {sub && (
        <div className="text-xs text-neutral-500 mt-2 tracking-wide">{sub}</div>
      )}
    </div>
  );
}
